var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskGptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81433 12.6324C1.87867 12.3401 1.85412 12.0353 1.74383 11.757C0.976343 10.1646 0.795944 8.35235 1.23446 6.63991C1.67297 4.92746 2.70221 3.42492 4.1406 2.39738C5.57898 1.36983 7.33406 0.883328 9.09619 1.02369C10.8583 1.16406 12.5143 1.92228 13.7718 3.16457C15.0294 4.40687 15.8078 6.0534 15.9697 7.81368C16.1316 9.57395 15.6665 11.3348 14.6566 12.7857C13.6467 14.2365 12.1568 15.284 10.4499 15.7434C8.7429 16.2028 6.92852 16.0445 5.32686 15.2966C5.06398 15.1968 4.77835 15.1728 4.50254 15.2276L1.94259 15.9761C1.8191 16.0089 1.68929 16.0096 1.56546 15.9781C1.44163 15.9466 1.3279 15.8841 1.23504 15.7963C1.14218 15.7085 1.07327 15.5985 1.03485 15.4767C0.996436 15.3548 0.989781 15.2252 1.01552 15.1L1.81433 12.6324Z",
    stroke: "#8F333B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskGptIcon);
export default __webpack_public_path__ + "static/media/ask-gpt-icon.317c8853930ef9a2be30cd5a7b4b42db.svg";
export { ForwardRef as ReactComponent };